module.exports = __webpack_public_path__ + "static/img/0.e9ac3f2c.png";